import React from "react";
import { motion } from "framer-motion";

const FloatingShapes = () => {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {/* Gradient orbs */}
      <div className="orb absolute top-1/4 -left-32 w-96 h-96 bg-primary-600/20 rounded-full blur-3xl" />
      <div
        className="orb absolute bottom-1/4 -right-32 w-80 h-80 bg-accent-cyan/15 rounded-full blur-3xl"
        style={{ animationDelay: "-3s" }}
      />
      <div
        className="orb absolute top-1/2 left-1/2 -translate-x-1/2 w-64 h-64 bg-accent-violet/10 rounded-full blur-3xl"
        style={{ animationDelay: "-5s" }}
      />

      {/* 3D floating cube */}
      <motion.div
        className="absolute top-20 right-[15%] preserve-3d"
        style={{ perspective: "800px" }}
        animate={{ rotateY: 360, rotateX: [0, 15, 0] }}
        transition={{
          rotateY: { duration: 30, repeat: Infinity, ease: "linear" },
          rotateX: { duration: 8, repeat: Infinity, ease: "easeInOut" },
        }}
      >
        <div
          className="w-16 h-16 md:w-20 md:h-20 border border-primary-500/30 bg-primary-500/5 backdrop-blur-sm"
          style={{ transform: "rotateX(45deg) rotateZ(45deg)" }}
        />
      </motion.div>

      {/* Floating ring */}
      <motion.div
        className="absolute bottom-32 left-[10%] w-24 h-24 md:w-32 md:h-32 border-2 border-accent-cyan/20 rounded-full"
        animate={{ rotate: 360, y: [0, -20, 0] }}
        transition={{
          rotate: { duration: 25, repeat: Infinity, ease: "linear" },
          y: { duration: 6, repeat: Infinity, ease: "easeInOut" },
        }}
      />

      {/* 3D diamond */}
      <motion.div
        className="absolute top-1/3 left-[8%] w-12 h-12 bg-gradient-to-br from-accent-violet/20 to-primary-500/20 backdrop-blur-sm"
        style={{ clipPath: "polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%)" }}
        animate={{ rotate: -360, scale: [1, 1.15, 1] }}
        transition={{
          rotate: { duration: 20, repeat: Infinity, ease: "linear" },
          scale: { duration: 4, repeat: Infinity, ease: "easeInOut" },
        }}
      />

      {/* Grid floor perspective */}
      <div
        className="absolute bottom-0 left-0 right-0 h-1/2 opacity-30"
        style={{ perspective: "500px", perspectiveOrigin: "50% 0%" }}
      >
        <div className="grid-floor absolute inset-0" />
      </div>

      {/* Floating dots */}
      {[...Array(6)].map((_, i) => (
        <motion.div
          key={i}
          className="absolute w-1.5 h-1.5 bg-primary-400/60 rounded-full"
          style={{
            top: `${15 + i * 12}%`,
            left: `${10 + i * 14}%`,
          }}
          animate={{
            y: [0, -30, 0],
            opacity: [0.3, 0.8, 0.3],
          }}
          transition={{
            duration: 4 + i,
            repeat: Infinity,
            ease: "easeInOut",
            delay: i * 0.5,
          }}
        />
      ))}
    </div>
  );
};

export default FloatingShapes;
